import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import QRCode from 'qrcode.react';

import ExternalLink from 'components/generic/ExternalLink.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import { selectCurrentSalonId, selectCurrentSalonName } from 'selectors/currentSalon.selectors';
import { selectTokenData } from 'selectors/stockManagement.selectors';

import { getQRData } from 'stocks/actions';
import HeaderStocksNavigation from 'stocks/components/HeaderStocksNavigation';

import CN from './CustomAuthLayout.module.scss';

const SCANNER_APP_URL = 'https://itunes.apple.com/gb/app/slick-stock-management/id1438551651?mt=8';
const FEATURE_POINTS = ['point1', 'point2', 'point3', 'point4'];

export const CustomAuthLayout = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();

  const salonId = useSelector(selectCurrentSalonId);
  const salonName = useSelector(selectCurrentSalonName);
  const tokenData = useSelector(selectTokenData);

  useEffect(() => {
    dispatch(getQRData());
  }, [dispatch]);

  return (
    <div className={cn(CN.component, { [CN.darkMode]: isDarkMode })}>
      <HeaderStocksNavigation />

      <article className={CN.layout}>
        <h1 className={CN.title}>{t('stocks.syncScanner.title')}</h1>
        <p className={CN.subtitle}>{t('stocks.syncScanner.subTitle')}</p>

        <div className={CN.steps}>
          <h3 className={CN.stepsTitle}>{t('stocks.syncScanner.featureListTitle')}</h3>
          {FEATURE_POINTS.map((key) => (
            <p key={key} className={CN.stepsDescription}>
              {S.dot}
              {S.space}
              {t(`stocks.syncScanner.${key}`)}
            </p>
          ))}
        </div>

        <div className={CN.steps}>
          <h3 className={CN.stepsTitle}>{t('stocks.syncScanner.stepsTitle')}</h3>
          <p className={CN.stepsDescription}>
            {t('stocks.syncScanner.bullet1.part1')}
            {S.space}
            <ExternalLink variant="inline" link={SCANNER_APP_URL}>
              {t('stocks.syncScanner.bullet1.part2')}
            </ExternalLink>
            {S.space}
            {t('stocks.syncScanner.bullet1.part3')}
          </p>
          <p className={CN.stepsDescription}>{t('stocks.syncScanner.bullet2')}</p>
          <p className={CN.stepsDescription}>{t('stocks.syncScanner.bullet3')}</p>
        </div>
        <p className={CN.note}>{t('stocks.syncScanner.noteMessage')}</p>

        <div className={CN.qrContainer}>
          <div className={CN.code}>
            {tokenData && (
              <QRCode
                size={160}
                value={JSON.stringify({
                  ...tokenData,
                  salonId,
                  salonName,
                })}
              />
            )}
          </div>
        </div>
      </article>
    </div>
  );
};
